module.exports = __webpack_public_path__ + "img/icon-transfer-transaction.d878a9c2.svg";